export default "__VITE_ASSET__D7gmIy17__";